// Module
var code = "<div class=\"HeaderTitle\"> <plan-icon class=\"HeaderTitle__icon\" plan-type=\"HeaderTitle.icon\"> </plan-icon> <h2 class=\"HeaderTitle__title\" data-hook=\"plan-header-name\"> {{ HeaderTitle.title }} </h2> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/headerTitle/headerTitle.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;